import React from 'react';

export const CollapsedIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M14.0001 4.5H18.4391L13.0018 9.93725L14.0625 10.9979L19.4998 5.56065V9.99973H20.9998V4C20.9998 3.44772 20.5521 3 19.9998 3H14.0001V4.5ZM10.0017 19.4979H5.56262L10.9999 14.0607L9.93923 13L4.50195 18.4373V13.9982H3.00195V19.9979C3.00195 20.5502 3.44967 20.9979 4.00195 20.9979H10.0017V19.4979Z"
                  fill="#445371"/>
        </svg>
    );
};
export const CurrentMenuIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M8 3H9.5H14.5H16C17.6569 3 19 4.34315 19 6V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V6C5 4.34315 6.34315 3 8 3ZM16 4.5C16.8284 4.5 17.5 5.17157 17.5 6V18C17.5 18.8284 16.8284 19.5 16 19.5H8C7.17157 19.5 6.5 18.8284 6.5 18V6C6.5 5.17157 7.17157 4.5 8 4.5V5C8 6.10457 8.89543 7 10 7H14C15.1046 7 16 6.10457 16 5V4.5ZM16.0147 11.0708L11.519 15.3797C11.2268 15.6598 10.7651 15.6575 10.4757 15.3746L8.00991 12.9642L9.05845 11.8916L11.0051 13.7945L14.9767 9.98784L16.0147 11.0708ZM9.5 4.5H14.5V5C14.5 5.27614 14.2761 5.5 14 5.5H10C9.72386 5.5 9.5 5.27614 9.5 5V4.5Z"
                  fill="#445371"/>
        </svg>
    );
};
export const ArchiveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M18 4.5H6C5.72386 4.5 5.5 4.72386 5.5 5V6H18.5V5C18.5 4.72386 18.2761 4.5 18 4.5ZM20 6.26756V5C20 3.89543 19.1046 3 18 3H6C4.89543 3 4 3.89543 4 5V6.26756C3.4022 6.61337 3 7.25972 3 8V11C2.44772 11 2 11.4477 2 12V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V10C22 9.44772 21.5523 9 21 9V8C21 7.25972 20.5978 6.61337 20 6.26756ZM5 7.5H19C19.2761 7.5 19.5 7.72386 19.5 8V9H11.2426C10.447 9 9.68393 9.31607 9.12132 9.87868L8 11H4.5V8C4.5 7.72386 4.72386 7.5 5 7.5ZM8.62132 12.5L9.06066 12.0607L10.182 10.9393C10.4633 10.658 10.8448 10.5 11.2426 10.5H20.5V18C20.5 18.8284 19.8284 19.5 19 19.5H5C4.17157 19.5 3.5 18.8284 3.5 18V12.5H8H8.62132ZM14 14.25H18V12.75H14V14.25Z"
                  fill="#445371"/>
        </svg>
    );
};
export const notificationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M17.3788 16.5L16.7683 8.65106C16.5861 6.30819 14.6318 4.5 12.2819 4.5H11.7181C9.36818 4.5 7.41389 6.30819 7.23167 8.65105L6.6212 16.5L17.3788 16.5ZM5.73619 8.53474L5.11667 16.5L4 16.5V18L5 18H6.50453H8.12602C8.57006 19.7252 10.1362 21 12 21C13.8638 21 15.4299 19.7252 15.874 18H17.4955H19H20V16.5H18.8833L18.2638 8.53474C18.0208 5.41092 15.4151 3 12.2819 3H11.7181C8.58487 3 5.97915 5.41092 5.73619 8.53474ZM14.292 18L9.70802 18C10.0938 18.883 10.9748 19.5 12 19.5C13.0252 19.5 13.9062 18.883 14.292 18Z"
                  fill="#445371"/>
        </svg>
    );
};
export const DownloadIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M8 10.3998H9.6V11.9998V14.3998H14.4V11.9998V10.3998H16H17.6373L12 4.76259L6.36274 10.3998H8ZM8 14.9998V13.5998V11.9998H6.4H4.91421C4.02331 11.9998 3.57714 10.9227 4.20711 10.2927L11.2929 3.20696C11.6834 2.81643 12.3166 2.81643 12.7071 3.20696L19.7929 10.2927C20.4229 10.9227 19.9767 11.9998 19.0858 11.9998H17.6H16V13.5998V14.9998C16 15.5521 15.5523 15.9998 15 15.9998H9C8.44772 15.9998 8 15.5521 8 14.9998ZM2 18.9999V15.9999H3.5V18.9999C3.5 19.276 3.72386 19.4999 4 19.4999H20C20.2761 19.4999 20.5 19.276 20.5 18.9999V15.9999H22V18.9999C22 20.1044 21.1046 20.9999 20 20.9999H4C2.89543 20.9999 2 20.1044 2 18.9999Z"
                  fill="#445371"/>
        </svg>
    );
};
export const burgerBlueIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M7.46906 10.5328L3.46973 6.52889L4.53099 5.46884L7.99978 8.94159L11.4698 5.46875L12.5309 6.52898L8.53024 10.5329C8.38955 10.6737 8.19867 10.7528 7.99963 10.7528C7.80059 10.7528 7.60972 10.6736 7.46906 10.5328Z"
                  fill="#858FA3"/>
        </svg>
    );
};
export const sortIconUp = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 12.75H2V11.25H14V12.75ZM2 8.75H10V7.25H2V8.75ZM2 4.75H6V3.25H2V4.75Z"
                fill="#0E1117"
            />
        </svg>
    );
};
export const sortIconDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 3.25H2V4.75H14V3.25ZM2 7.25H10V8.75H2V7.25ZM2 11.25H6V12.75H2V11.25Z"
                fill="#0E1117"
            />
        </svg>
    );
};
export const RepairIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none">
            <path
                d="M9.61977 4.17028C9.4848 4.30798 9.4092 4.49311 9.4092 4.68593C9.4092 4.87875 9.4848 5.06389 9.61977 5.20159L10.7984 6.38023C10.9361 6.5152 11.1212 6.5908 11.3141 6.5908C11.5069 6.5908 11.692 6.5152 11.8297 6.38023L13.5847 4.62524C14.0789 4.13103 14.9105 4.29777 14.9788 4.99334C15.0187 5.39948 15.0024 5.81147 14.9284 6.21753C14.7674 7.10145 14.3407 7.91529 13.7054 8.5506C13.0701 9.18591 12.2563 9.61252 11.3724 9.77357C10.7164 9.89308 10.045 9.86215 9.40784 9.68688C9.00652 9.57648 8.56307 9.64688 8.26875 9.9412L3.66764 14.5423C3.37459 14.8354 2.97712 15 2.56267 15C2.14822 15 1.75075 14.8354 1.4577 14.5423C1.16464 14.2492 1 13.8518 1 13.4373C1 13.0229 1.16464 12.6254 1.4577 12.3324L6.0588 7.73125C6.35312 7.43693 6.42352 6.99348 6.31313 6.59216C6.13785 5.95496 6.10692 5.28356 6.22643 4.62763C6.38748 3.74371 6.81409 2.92987 7.4494 2.29456C8.08471 1.65925 8.89855 1.23264 9.78247 1.07159C10.1885 0.997605 10.6005 0.981277 11.0067 1.02116C11.7022 1.08946 11.869 1.92108 11.3748 2.4153L9.62714 4.16291L9.61977 4.17028Z"
                stroke="#0E1117"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const burgerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2.25H1V3.75H15V2.25ZM1 7.25H15V8.75H1V7.25ZM1 12.25H15V13.75H1V12.25Z"
                fill="#0E1117"
            />
        </svg>
    );
};
export const EditIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M11.7428 5.85767L13.5763 4.02418C13.9023 3.69816 14.4317 3.69816 14.7578 4.02418L15.9781 5.24456C16.303 5.56942 16.303 6.09524 15.9782 6.42009L14.1417 8.25657L11.7428 5.85767ZM10.8589 6.74156L4.29038 13.3102C4.21237 13.3882 4.16856 13.4939 4.16856 13.604V15.834L6.39121 15.834C6.50203 15.834 6.60831 15.79 6.68658 15.7118L13.2578 9.14046L10.8589 6.74156ZM7.5727 16.5934C7.25963 16.9065 6.83453 17.0824 6.39121 17.0824L3.33419 17.0824C3.10378 17.0824 2.91699 16.8961 2.91699 16.6663V13.604C2.91699 13.1633 3.09223 12.7405 3.40426 12.4285L12.6902 3.14253C13.5052 2.32749 14.8288 2.32749 15.6439 3.14254L16.8642 4.36292C17.6764 5.17506 17.6764 6.48961 16.8643 7.30174L7.5727 16.5934Z"
                  fill="#858FA3"/>
        </svg>
    );
};
export const arrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M13.9879 10.9351L12.4621 12.4609L13.7879 13.7868L16.9129 10.6617C17.279 10.2956 17.279 9.70203 16.9129 9.33591L13.7879 6.21094L12.4621 7.53676L13.9854 9.06012L2.5 9.06012L2.5 10.9351L13.9879 10.9351Z"
                  fill="#858FA3"/>
        </svg>
    );
};
export const errorImportIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none">
            <path
                opacity="0.7"
                d="M53.875 29.5C53.875 42.9619 42.9619 53.875 29.5 53.875C16.0381 53.875 5.125 42.9619 5.125 29.5C5.125 16.0381 16.0381 5.125 29.5 5.125C42.9619 5.125 53.875 16.0381 53.875 29.5Z"
                fill="#E45563"
            />
            <path
                d="M27.7882 33.3095H31.2007L31.7467 26.0932V17.8008H27.2422V26.0932L27.7882 33.3095ZM27.2422 41.6883H31.7467V36.979H27.2422V41.6883Z"
                fill="#301D00"
            />
        </svg>
    );
};
export const DeleteRedBtn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85633 4.00153C4.98293 2.86205 5.94608 2 7.09256 2H8.90744C10.0539 2 11.0171 2.86206 11.1437 4.00153L11.1991 4.5H13V6H12.3423L12.3422 6.00087L11.6885 12.2101C11.5813 13.228 10.723 14.0007 9.69949 14.0007H6.30053C5.27701 14.0007 4.41866 13.228 4.31152 12.2101L3.65796 6.00087L3.65786 6H3V4.5H4.80094L4.85633 4.00153ZM9.65285 4.16718L9.68983 4.5H6.31017L6.34715 4.16718C6.38935 3.78735 6.7104 3.5 7.09256 3.5H8.90744C9.2896 3.5 9.61065 3.78735 9.65285 4.16718ZM5.80328 12.0531L5.16624 6.00087H10.8339L10.1967 12.0531C10.17 12.3075 9.95537 12.5007 9.69949 12.5007H6.30053C6.04465 12.5007 5.83007 12.3075 5.80328 12.0531Z"
        fill="#EC818C"
      />
    </svg>
  );
};
export const languageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 13.6666C8.45917 13.6666 8.90566 13.612 9.33325 13.5088V14.5332C8.90244 14.6207 8.45654 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 8.45654 14.6207 8.90244 14.5332 9.33325H13.5088C13.5741 9.06253 13.62 8.78424 13.6448 8.49992H11.3239C11.3133 8.78027 11.2939 9.0586 11.2659 9.33325H10.2603C10.2906 9.0599 10.3117 8.78145 10.3231 8.49992H5.67673C5.68853 8.78994 5.71065 9.07945 5.74327 9.36616C5.89476 10.6976 6.25698 11.8329 6.72808 12.6146C7.2106 13.4152 7.67336 13.6437 7.94904 13.6646L7.94891 13.6664C7.9659 13.6665 7.9829 13.6666 7.99992 13.6666ZM5.97375 13.2936C5.93923 13.2407 5.90517 13.1865 5.8716 13.1308C5.30687 12.1937 4.91251 10.9102 4.74968 9.47921C4.71283 9.15534 4.68831 8.82801 4.67597 8.49992H2.35501C2.54711 10.6973 3.99332 12.5351 5.97375 13.2936ZM5.67674 7.49992H10.3231C10.3221 7.47604 10.3211 7.45216 10.32 7.42827C10.2566 6.0672 9.97077 4.82399 9.53754 3.88898C9.09158 2.92646 8.58986 2.49481 8.23752 2.37461C7.9778 2.28601 7.62549 2.31106 7.17015 2.79162C6.68722 3.3013 6.22897 4.20718 5.94567 5.44021C5.79622 6.09067 5.70567 6.78877 5.67674 7.49992ZM11.3239 7.49992H13.6448C13.4527 5.30257 12.0065 3.46471 10.0261 2.70624C10.1755 2.93493 10.3157 3.18968 10.4449 3.46858C10.9436 4.54501 11.2509 5.92052 11.3189 7.38176C11.3207 7.42115 11.3224 7.46053 11.3239 7.49992ZM5.97375 2.70624C5.54443 3.36353 5.19916 4.22354 4.97106 5.21628C4.80451 5.9412 4.7055 6.71486 4.67597 7.49992H2.35501C2.54711 5.30257 3.99332 3.46471 5.97375 2.70624ZM11.8333 14.3333V12.8333H10.3333V11.8333H11.8333V10.3333H12.8333V11.8333H14.3333V12.8333H12.8333V14.3333H11.8333Z"
        fill="#0048D9"
      />
    </svg>
  );
};
export const DeleteRed20 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.07041 5.00191C6.22867 3.57757 7.4326 2.5 8.86571 2.5H11.1343C12.5674 2.5 13.7713 3.57757 13.9296 5.00191L13.9988 5.625H16.25V7.5H15.4278L15.4277 7.50109L14.6106 15.2626C14.4767 16.535 13.4038 17.5009 12.1244 17.5009H7.87567C6.59627 17.5009 5.52333 16.535 5.3894 15.2626L4.57244 7.50109L4.57233 7.5H3.75V5.625H6.00117L6.07041 5.00191ZM12.0661 5.20897L12.1123 5.625H7.88771L7.93394 5.20897C7.98669 4.73419 8.388 4.375 8.86571 4.375H11.1343C11.612 4.375 12.0133 4.73419 12.0661 5.20897ZM7.2541 15.0663L6.4578 7.50109H13.5423L12.7459 15.0663C12.7124 15.3844 12.4442 15.6259 12.1244 15.6259H7.87567C7.55582 15.6259 7.28758 15.3844 7.2541 15.0663Z"
        fill="#D91528"
      />
    </svg>
  );
};
export const EmailInputIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 6.84131V13.751C3.125 14.7865 3.96447 15.626 5 15.626H15C16.0355 15.626 16.875 14.7865 16.875 13.751V6.84131L10.6322 12.5422C10.2741 12.8692 9.72586 12.8692 9.36782 12.5422L3.125 6.84131ZM16.7941 4.37598H3.20586L10 10.5803L16.7941 4.37598ZM1.25 3.75098C1.25 3.06062 1.80964 2.50098 2.5 2.50098H17.5C18.1904 2.50098 18.75 3.06062 18.75 3.75098V13.751C18.75 15.822 17.0711 17.501 15 17.501H5C2.92893 17.501 1.25 15.822 1.25 13.751V3.75098Z"
        fill="#858FA3"
      />
    </svg>
  );
};
export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.55086 0.00585938L1.64693 0.155126C2.99415 2.1154 5.3308 3.42136 7.9998 3.42136C10.6682 3.42136 13.0043 2.11601 14.3517 0.156511L14.4446 0.00983806L15.5007 0.678396L15.4017 0.834899C15.3976 0.84132 15.3934 0.847665 15.3891 0.853933C13.8097 3.15862 11.0846 4.67136 7.9998 4.67136C4.91523 4.67136 2.19035 3.15888 0.610868 0.854524C0.607451 0.849539 0.604107 0.844506 0.600836 0.839424L0.499756 0.682374L1.55086 0.00585938ZM7.3752 6.33376L7.3752 8.83376H8.6252V6.33376H7.3752ZM2.59427 5.08772L1.34427 7.17105L2.41613 7.81417L3.66613 5.73084L2.59427 5.08772ZM14.6559 7.17105L13.4059 5.08772L12.3341 5.73084L13.5841 7.81417L14.6559 7.17105Z"
        fill="#858FA3"
      />
    </svg>
  );
};
export const LockIcon = () => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7.4997H5V4.37402C5 2.99358 6.11886 1.87441 7.4993 1.87402C8.88029 1.87364 10 2.99304 10 4.37402V7.4997ZM3.125 4.37402V7.4997H1.25C0.559644 7.4997 0 8.05935 0 8.7497V14.9997C0 17.0708 1.67893 18.7497 3.75 18.7497H11.25C13.3211 18.7497 15 17.0708 15 14.9997V8.7497C15 8.05935 14.4404 7.4997 13.75 7.4997H11.875V4.37402C11.875 1.9573 9.9155 -0.00165034 7.49878 -0.000976389C5.08301 -0.000302086 3.125 1.95826 3.125 4.37402ZM1.875 9.3747V14.9997C1.875 16.0352 2.71447 16.8747 3.75 16.8747H11.25C12.2855 16.8747 13.125 16.0352 13.125 14.9997V9.3747H1.875ZM7.5 14.9997C8.53553 14.9997 9.375 14.1602 9.375 13.1247C9.375 12.0892 8.53553 11.2497 7.5 11.2497C6.46447 11.2497 5.625 12.0892 5.625 13.1247C5.625 14.1602 6.46447 14.9997 7.5 14.9997Z"
        fill="#858FA3"
      />
    </svg>
  );
};
export const openEyeIcon = () => {
  return (
    <svg
      data-icon="anticon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6248 5.8335L10.6248 3.3335H9.37481V5.8335H10.6248ZM15.4057 7.07954L16.6557 4.9962L15.5839 4.35308L14.3339 6.43642L15.4057 7.07954ZM3.34409 4.9962L4.59409 7.07954L5.66596 6.43642L4.41596 4.35308L3.34409 4.9962ZM3.89919 11.6674C5.27504 13.4317 7.49012 14.5842 9.99901 14.5842C12.5081 14.5842 14.7234 13.4315 16.0992 11.667C15.2358 10.5598 14.0418 9.6935 12.6521 9.20182C12.8219 9.57171 12.9165 9.98322 12.9165 10.4168C12.9165 12.0277 11.6107 13.3335 9.99982 13.3335C8.38899 13.3335 7.08316 12.0277 7.08316 10.4168C7.08316 9.98308 7.17784 9.57144 7.34766 9.20146C5.95735 9.69314 4.76287 10.5597 3.89919 11.6674ZM17.3888 11.3133C15.8091 9.01109 13.0841 7.50025 9.99967 7.50016H9.99939C6.91459 7.50016 4.1893 9.01128 2.60962 11.3139C2.46345 11.527 2.46346 11.808 2.60965 12.0211C4.18939 14.3234 6.91448 15.8342 9.99901 15.8342C13.0838 15.8342 15.8091 14.3231 17.3888 12.0205C17.535 11.8074 17.5349 11.5264 17.3888 11.3133ZM9.99982 12.0835C10.9203 12.0835 11.6665 11.3373 11.6665 10.4168C11.6665 9.49636 10.9203 8.75016 9.99982 8.75016C9.07935 8.75016 8.33316 9.49636 8.33316 10.4168C8.33316 11.3373 9.07935 12.0835 9.99982 12.0835Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ExitIcon = () =>{
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="24 / Place / Door Exit">
        <path id="Union" fillRule="evenodd" clipRule="evenodd"
              d="M7 3.5H17C17.2761 3.5 17.5 3.72386 17.5 4V20C17.5 20.2761 17.2761 20.5 17 20.5H7C6.72386 20.5 6.5 20.2761 6.5 20V12.749H10.4401L8.71431 14.4748L9.77497 15.5354L12.7802 12.5302C13.0731 12.2374 13.0731 11.7625 12.7802 11.4696L9.77496 8.46435L8.7143 9.52502L10.4382 11.249H6.5V4C6.5 3.72386 6.72386 3.5 7 3.5ZM5 11.249V4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V12.749H3V11.249H5Z"
              fill="#445371" />
      </g>
    </svg>

  )
}
export const bullIconGreen = () =>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11Z"
        fill="#00B288" />
    </svg>
  )
}
export const bullIconWhite = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11Z"
        fill="#FFFFFF" />
    </svg>
  )
}
